module.exports = __webpack_public_path__ + "img/07.0a6cb345.png";